var React = require('react');

function PlaceOfWorship (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M620.61 366.55L512 320v192h112a16 16 0 0 0 16-16V396a32 32 0 0 0-19.39-29.45zM0 396v100a16 16 0 0 0 16 16h112V320L19.39 366.55A32 32 0 0 0 0 396z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 102.63v115l48.46 29.08A32 32 0 0 1 480 274.12V512h-96v-96a64 64 0 0 0-128 0v96h-96V274.12a32 32 0 0 1 15.54-27.44L224 217.6v-115a32 32 0 0 1 9.38-22.6l75.31-75.31a16 16 0 0 1 22.62 0L406.62 80a32 32 0 0 1 9.38 22.63z","className":"fa-primary","key":2})]);
}

PlaceOfWorship.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = PlaceOfWorship;

PlaceOfWorship.default = PlaceOfWorship;
